export default "__VITE_ASSET__BTaYitT5__"